// @ts-nocheck
import { yupResolver } from "@hookform/resolvers/yup";
import { Empty } from "antd";
import FormInput from "components/Common/Form/FormInput";
import ConfirmModal from "components/shared-components/ConfirmModal";
import {
  useCreateHubContact,
  useDeleteHubContact,
  useUpdateHubContact,
} from "hooks/hub-contact/useHubContact";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import { validateSchema, validateSchemaAddHubContac } from "./validate";

const ContactRow = ({
  itemData,
  index,
  refetchHubContact,
  isAddNew,
  hubId,
  viewMode,
}) => {
  const { t } = useTranslation(["hub"]);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);

  const mainForm = useForm({
    resolver: yupResolver(validateSchemaAddHubContac(t)),
    mode: "all",
    reValidateMode: "onChange",
  });

  const { setValue, reset, register, getValues, handleSubmit } = mainForm;

  const { mutate: updateHubContact } = useUpdateHubContact(
    () => {
      reset({});
      setIsEdit(false);
      refetchHubContact();
    },
    () => {}
  );

  const { mutate: deleteHubContact } = useDeleteHubContact(
    () => {
      reset({});
      setIsEdit(false);
      setIsOpenConfirmModal(false);
      refetchHubContact();
    },
    () => {}
  );

  useEffect(() => {
    if (isAddNew) setIsEdit(false);
  }, [isAddNew]);

  const setDefaultData = data => {
    setValue(`contact_person_name_add`, data?.name, { shouldValidate: true });
    setValue(`contact_person_phone_1_add`, data?.phone1, {
      shouldValidate: true,
    });
    setValue(`contact_person_phone_2_add`, data?.phone2, {
      shouldValidate: true,
    });
    setValue(`is_default_add`, data?.is_default === 1 ? true : false);
  };

  useEffect(() => {
    setDefaultData(itemData);
  }, [itemData]);

  const onCancel = () => {
    reset({});
    setDefaultData(itemData);
    setIsEdit(false);
  };

  const onSave = values => {
    const isDefault = values[`is_default_add`];

    updateHubContact({
      hubContactId: itemData?.id,
      data: {
        hub_id: hubId,
        name: values[`contact_person_name_add`],
        phone1: values[`contact_person_phone_1_add`],
        phone2: values[`contact_person_phone_2_add`],
        is_default: isDefault ? 1 : 0,
      },
    });
  };

  const confirmModal = () => {
    deleteHubContact(itemData?.id);
  };

  return (
    <Row className="ContactRow">
      <Col xs={viewMode ? 12 : 11}>
        <Row>
          <Col xs={4}>
            <FormGroup>
              <FormInput
                isLabel={false}
                t={t}
                fieldName={`contact_person_name_add`}
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", {
                  title: t("form.contact_person_name"),
                })}
                isDisabled={!isEdit}
              />
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <FormInput
                isLabel={false}
                t={t}
                fieldName={`contact_person_phone_1_add`}
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", {
                  title: t("form.contact_person_phone_1"),
                })}
                isDisabled={!isEdit}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <FormInput
                isLabel={false}
                t={t}
                fieldName={`contact_person_phone_2_add`}
                type="text"
                mainForm={mainForm}
                title={t("placeholder.enter", {
                  title: t("form.contact_person_phone_2"),
                })}
                isDisabled={!isEdit}
              />
            </FormGroup>
          </Col>
          <Col
            xs={1}
            className="d-flex flex-row justify-content-center align-items-center"
          >
            <FormGroup>
              <input
                id={`is_default_add`}
                type="checkbox"
                disabled={!isEdit}
                // onChangeCapture={onChangeIsCenter}
                {...register(`is_default_add`)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
      {!viewMode && (
        <Col
          className="d-flex flex-row justify-content-start align-items-baseline"
          xs={1}
        >
          {!isEdit && (
            <>
              <UncontrolledTooltip placement="top" target="btnEdit">
                {t("button.update")}
              </UncontrolledTooltip>
              <button
                id="btnEdit"
                type="button"
                className="btn"
                onClick={() => setIsEdit(true)}
              >
                <i className="fas fa-pen fa-2xs text-info" />
              </button>
              {itemData?.is_default !== 1 && (
                <>
                  <UncontrolledTooltip placement="top" target="btnDelete">
                    {t("button.delete")}
                  </UncontrolledTooltip>
                  <button
                    onClick={() => setIsOpenConfirmModal(true)}
                    id="btnDelete"
                    type="button"
                    className="btn"
                  >
                    <i className="fas fa-trash fa-2xs text-danger" />
                  </button>
                </>
              )}
            </>
          )}
          {isEdit && (
            <>
              <Button
                size="sm"
                color="primary"
                id="btnSave"
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit(onSave)}
              >
                {t("button.save")}
              </Button>
              <Button
                size="sm"
                color="danger"
                id="btnCancel"
                type="button"
                className="btn btn-primary mx-2 my-1"
                onClick={onCancel}
              >
                {t("button.cancel")}
              </Button>
            </>
          )}
        </Col>
      )}
      <ConfirmModal
        isOpen={isOpenConfirmModal}
        titleHeader={t("actions.confirmActiveModal.titleDelete")}
        titleBody={t("actions.confirmActiveModal.contentDelete")}
        onConfirm={confirmModal}
        textBtnConfirm={t("actions.confirmActiveModal.confirmBtn")}
        textBtnCancel={t("actions.confirmActiveModal.cancelBtn")}
        toggle={() => setIsOpenConfirmModal(false)}
      />
    </Row>
  );
};

const AddContact = ({
  setIsAddNew,
  hubId,
  refetchHubContact,
  isFirstContact,
}) => {
  const { t } = useTranslation(["hub"]);

  const mainForm = useForm({
    resolver: yupResolver(validateSchemaAddHubContac(t)),
    mode: "all",
    reValidateMode: "onChange",
  });

  const { register, reset, setValue, getValues, handleSubmit } = mainForm;

  const { mutate: createHubContact } = useCreateHubContact(
    () => {
      reset({});
      setIsAddNew(false);
      refetchHubContact();
    },
    () => {}
  );
  useEffect(() => {
    if (isFirstContact) {
      setValue("is_default_add", true);
    }
  }, [isFirstContact]);

  const onSave = () => {
    const {
      contact_person_name_add,
      contact_person_phone_1_add,
      contact_person_phone_2_add,
      is_default_add,
    } = getValues();

    createHubContact({
      hub_id: hubId,
      name: contact_person_name_add,
      phone1: contact_person_phone_1_add,
      phone2: contact_person_phone_2_add,
      is_default: is_default_add ? 1 : 0, // 1 là người liên hệ mặc đinh, 0 là không
    });
  };

  return (
    <>
      <Row className="AddContact">
        <Col xs={11}>
          <Row>
            <Col xs={4}>
              <FormGroup>
                <FormInput
                  isLabel={false}
                  t={t}
                  fieldName={`contact_person_name_add`}
                  type="text"
                  mainForm={mainForm}
                  title={t("placeholder.enter", {
                    title: t("form.contact_person_name"),
                  })}
                />
              </FormGroup>
            </Col>
            <Col xs={4}>
              <FormGroup>
                <FormInput
                  isLabel={false}
                  t={t}
                  fieldName={`contact_person_phone_1_add`}
                  type="text"
                  mainForm={mainForm}
                  title={t("placeholder.enter", {
                    title: t("form.contact_person_phone_1"),
                  })}
                />
              </FormGroup>
            </Col>
            <Col xs={3}>
              <FormGroup>
                <FormInput
                  isLabel={false}
                  t={t}
                  fieldName={`contact_person_phone_2_add`}
                  type="text"
                  mainForm={mainForm}
                  title={t("placeholder.enter", {
                    title: t("form.contact_person_phone_2"),
                  })}
                />
              </FormGroup>
            </Col>
            <Col
              xs={1}
              className="d-flex flex-row justify-content-center align-items-center"
            >
              <FormGroup>
                <input
                  id={`is_default_add`}
                  type="checkbox"
                  // onChangeCapture={onChangeIsCenter}
                  {...register(`is_default_add`)}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="text-start">
          <Button
            size="xs"
            style={{ backgroundColor: "#3C64B1" }}
            onClick={handleSubmit(onSave)}
            className="btn btn-primary btn-label"
          >
            <i className="fas fa-save label-icon"></i>
            {t("button.save")}
          </Button>
          <Button
            size="xs"
            className="mx-3 btn btn-danger btn-label"
            onClick={() => setIsAddNew(false)}
          >
            <i className="fas fa-ban label-icon"></i>
            {t("button.cancel")}
          </Button>
        </Col>
      </Row>
    </>
  );
};

const ContactFormSection = props => {
  const { contact, hubId, refetchHubContact, viewMode } = props;
  const [isAddNew, setIsAddNew] = useState(false);
  const { t } = useTranslation(["hub"]);

  const mainForm = useForm({
    resolver: yupResolver(validateSchema(t)),
    mode: "all",
    reValidateMode: "onChange",
  });

  const renderContactList = useMemo(() => {
    if (contact && contact.items && contact.items.length > 0) {
      return contact.items.map((item, index) => (
        <ContactRow
          refetchHubContact={refetchHubContact}
          key={index}
          index={index}
          itemData={item}
          isAddNew={isAddNew}
          hubId={hubId}
          viewMode={viewMode}
        />
      ));
    }
    return <></>;
  }, [contact, isAddNew]);

  return (
    <Card className="ContactFormSection" style={{ overflowX: "auto" }}>
      <CardBody style={{ minWidth: "600px" }}>
        {/* <Row>
          <h5>{t("title.contact")}</h5>
        </Row> */}
        {contact?.items && contact?.items?.length > 0 ? (
          <Row>
            <Col xs={viewMode ? 12 : 11}>
              <Row>
                <Col xs={4}>
                  <FormGroup>
                    <Label>
                      {t("form.contact_person_name")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                  </FormGroup>
                </Col>
                <Col xs={4}>
                  <FormGroup>
                    <Label>
                      {t("form.contact_person_phone_1")}{" "}
                      <span className="text-danger">*</span>
                    </Label>
                  </FormGroup>
                </Col>
                <Col xs={3}>
                  <FormGroup>
                    <Label>{t("form.contact_person_phone_2")} </Label>
                  </FormGroup>
                </Col>
                <Col xs={1} className="text-center">
                  <FormGroup>
                    <Label>{t("form.default_contact")} </Label>
                  </FormGroup>
                </Col>
              </Row>
            </Col>
            <Col
              className="d-flex flex-row justify-content-center align-items-center"
              xs={1}
            ></Col>
          </Row>
        ) : (
          viewMode && <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
        {renderContactList}
        {isAddNew && (
          <AddContact
            refetchHubContact={refetchHubContact}
            hubId={hubId}
            setIsAddNew={setIsAddNew}
            isFirstContact={contact?.items?.length < 1}
          />
        )}
        {!isAddNew && !viewMode && (
          <Row>
            <Col className="text-start">
              <Button
                size="xs"
                id="btnAdd"
                style={{ backgroundColor: "#3C64B1" }}
                onClick={() => {
                  contact?.items?.length < 3 && setIsAddNew(true);
                }}
                className="btn btn-primary btn-label"
              >
                <i className="fas fa-plus label-icon" />
                {t("button.add", { target: t("title.contact_person") })}
              </Button>
              {contact?.items?.length >= 3 && (
                <UncontrolledTooltip placement="right" target="btnAdd">
                  <i className="mx-3 text-danger">
                    * Mỗi hub/center chỉ có thể có tối đa 3 người liên hệ
                  </i>
                </UncontrolledTooltip>
              )}
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default ContactFormSection;
